import theme from './default'

export default {
  mainNavWidth: theme.spacing(11),
  mainNavItemHeight: theme.spacing(8),
  secondaryNavWidthCollapsed: theme.spacing(7),
  secondaryNavWidthExpanded: theme.spacing(36),
  sidePanelWidthSmall: theme.spacing(40),
  sidePanelWidthMedium: theme.spacing(50),
  sidePanelWidthLarge: theme.spacing(60),
  modalDrawerWidthSmall: theme.spacing(84),
  modalDrawerWidthMedium: theme.spacing(114),
  modalDrawerWidthLarge: theme.spacing(144),
  childScreenContentWidthSmall: theme.spacing(100),
  childScreenContentWidthMedium: theme.spacing(140),
  childScreenContentWidthLarge: theme.spacing(160),
}
